// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.regularise-container {
  width: 80%;
  height: 70%;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  overflow:auto;
}

h2 {
  text-align: center;
  margin-bottom: 15px;
}

/* Header Section */
.regularise-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.add-btn {
  background: #84C7AE;
  color: white;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}
.regulariseContantDiv{
  height: 65%;
  overflow-y:scroll;
}
/* Table Headers */
.regularise-table-header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  background: #f0f0f0;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.regularise-table-header span {
  flex: 1 1;
  text-align: center;
}

/* Table Rows */
.regularise-row {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 8px;
}

.regularise-row input {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.remove-btn {
  font-size: 18px;
  color: black;
  border: none;
  padding: 5px;
  cursor: pointer;
  font-weight: 700;

}

/* Buttons */
.regulariseButtons {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.cancel-btn {
  background: #ccc;
  color: black;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit {
  background: #84C7AE;
  color: white;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
}





/* Hide the actual date input */
.hidden-date-input {
  position: absolute;
  opacity: 0;
 
  pointer-events: none;
left: 75%;
}





/* added calender  */

.calendar-container {
  margin-top: -24px;
  padding: 10px;
  border: 1px solid #ccc;
  width: 450px;
  position: absolute;
  border-radius: 10px;
  right: 180px;
  background-color: aliceblue;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color:#4b7d6b;
}
.calendar-header_arrow_left {
  font-size: 22px;
  font-weight: 700;

  padding-left: 20px;
}
.calendar-header_arrow_right {
  font-size: 22px;
  font-weight: 700;

  padding-right: 20px;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
}

.calendar-day-header {
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  padding: 5px;
color: #84C7AE;
}

.calendar-day {
  padding: 5px;
  border: 1px solid #eee;
  cursor: pointer;
}

.calendar-day p {
  font-size: 12px;
  color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/utils/RegulariseForm/RegulariseForm.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;;AAElB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;;;;;AAMA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;;EAEV,oBAAoB;AACtB,SAAS;AACT;;;;;;AAMA,oBAAoB;;AAEpB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;AACd,cAAc;AACd;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".regularise-container {\n  width: 80%;\n  height: 70%;\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  overflow:auto;\n}\n\nh2 {\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n/* Header Section */\n.regularise-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n\n.add-btn {\n  background: #84C7AE;\n  color: white;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n.regulariseContantDiv{\n  height: 65%;\n  overflow-y:scroll;\n}\n/* Table Headers */\n.regularise-table-header {\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n  background: #f0f0f0;\n  padding: 8px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n.regularise-table-header span {\n  flex: 1;\n  text-align: center;\n}\n\n/* Table Rows */\n.regularise-row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.regularise-row input {\n  flex: 1;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.remove-btn {\n  font-size: 18px;\n  color: black;\n  border: none;\n  padding: 5px;\n  cursor: pointer;\n  font-weight: 700;\n\n}\n\n/* Buttons */\n.regulariseButtons {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.cancel-btn {\n  background: #ccc;\n  color: black;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit {\n  background: #84C7AE;\n  color: white;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n\n\n\n\n/* Hide the actual date input */\n.hidden-date-input {\n  position: absolute;\n  opacity: 0;\n \n  pointer-events: none;\nleft: 75%;\n}\n\n\n\n\n\n/* added calender  */\n\n.calendar-container {\n  margin-top: -24px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  width: 450px;\n  position: absolute;\n  border-radius: 10px;\n  right: 180px;\n  background-color: aliceblue;\n}\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color:#4b7d6b;\n}\n.calendar-header_arrow_left {\n  font-size: 22px;\n  font-weight: 700;\n\n  padding-left: 20px;\n}\n.calendar-header_arrow_right {\n  font-size: 22px;\n  font-weight: 700;\n\n  padding-right: 20px;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  text-align: center;\n}\n\n.calendar-day-header {\n  font-weight: bold;\n  border-bottom: 1px solid #ccc;\n  padding: 5px;\ncolor: #84C7AE;\n}\n\n.calendar-day {\n  padding: 5px;\n  border: 1px solid #eee;\n  cursor: pointer;\n}\n\n.calendar-day p {\n  font-size: 12px;\n  color: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
